import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, mapTo, tap } from 'rxjs/operators';
import { environment } from '@environment';
import { AppApiService } from '@shared/core/services/app-api.service';
import { AuthorizedUser, BackendApiResponse, UserRole } from '@shared/core/types';
import { convertApiItemResponseToItem } from '@shared/core/utils';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  protected baseEndpoint = environment.crm.backend.baseEndpoint;

  private user: AuthorizedUser | null = null;

  constructor(protected api: AppApiService) {}

  isAuthenticated(): boolean {
    return Boolean(this.user);
  }

  getUser(): AuthorizedUser | null {
    return this.user;
  }

  loadUser(): Observable<boolean> {
    return this.api.get<BackendApiResponse<AuthorizedUser>>(`${this.baseEndpoint}session`).pipe(
      convertApiItemResponseToItem,
      tap(user => (this.user = user)),
      mapTo(true),
      catchError(() => {
        this.user = null;
        return of(false);
      }),
    );
  }

  hasRole(role: UserRole): boolean {
    return this.isAuthenticated() && this.user.roles.includes(role);
  }
}
